export default __webpack_public_path__ + "static/media/LANDMARKS-ID-Logo-no-strap.81c13db7.svg";